export const CREATE_ROLE = "CREATE_ROLE";
export const LOAD_CREATED_ROLES = "LOAD_CREATED_ROLES";
export const EDIT_ROLE = "EDIT_ROLE";
export const DELETE_ROLE = "DELETE_ROLE";
export const GET_ROLE_BY_ID = "GET_ROLE_BY_ID"